import {ValueObject} from '@s-ui/domain'

import {FuelTypeValueObject} from './FuelTypeValueObject.js'

export class FuelTypeListValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static createFromPrimitives({value}) {
    return new FuelTypeListValueObject({
      value: value?.items.map(({name, fuelTypeId}) =>
        FuelTypeValueObject.createFromPrimitives({
          name,
          fuelTypeId
        })
      )
    })
  }

  get value() {
    return this.#value.map(fuelType => fuelType.value)
  }
}
